import classNames from "classnames";
import React from "react";
import { AddToCartType } from "tsi-common-react/src/constants";
import { trackAddToBasketEvent } from "tsi-common-react/src/utils/analytics";
import { format } from "tsi-common-react/src/utils/format";
import { t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

import { IBasketLineSuggestionProps } from "../BasketLineSuggestion.interfaces";

const buildAddToBasketButton = (
    product: IBasketLineSuggestionProps["product"],
    onAddToBasket: () => void,
): React.ReactNode => {
    let addToCartLabel: string = t`Add to cart`;
    let isPreorder = false;
    if (
        product.attributes &&
        product.attributes.preorder &&
        product.attributes.preorder.value
    ) {
        addToCartLabel = t`Pre-Order`;
        isPreorder = true;
    }

    const buttonClasses = classNames({
        "button": true,
        "button--secondary": isPreorder,
    });

    return (
        <button className={buttonClasses} onClick={onAddToBasket}>
            {addToCartLabel}
        </button>
    );
};

export const BasketLineSuggestionC = (
    props: IBasketLineSuggestionProps,
): React.ReactNode => {
    const addToBasket = async (): Promise<void> => {
        await props.addBasketLine(props.product.url, 1);
        trackAddToBasketEvent(
            props.product,
            1,
            AddToCartType.IN_CART_UP_CROSS_SELL,
        );
    };

    return (
        <div
            role="region"
            aria-label={t`Upsell Carousel`}
            className="basket-suggestion-c"
        >
            <div className="basket-suggestion-c__header">
                <div className="basket-suggestion-c__title basket-suggestion-c__title">
                    {t`$300 Instant Credit!`}
                </div>
                <span className="basket-suggestion-c__subtitle">
                    {richT(
                        t`Add the TEMPUR-Ergo<sup>®</sup> Plus! to your order and get $300 instant credit!<sup>*</sup>`,
                    )}
                </span>
            </div>
            <div className="basket-suggestion-c__content">
                <div className="basket-suggestion-c__content--left basket-suggestion-c__content--left-2"></div>
                <div className="basket-suggestion-c__content--right">
                    <div className="basket-suggestion-c__list-container">
                        <div className="basket-suggestion-c__list-title">
                            {richT(
                                t`Why You'll Love The TEMPUR-Ergo<sup>®</sup> Plus!`,
                            )}
                        </div>
                        <ul className="basket-suggestion-c__list">
                            <li className="basket-suggestion-c__list-item">
                                {t`Lifts your head and feet to the perfect position.`}
                            </li>
                            <li className="basket-suggestion-c__list-item">
                                {t`Personalized comfort for reading, relaxing, and sleeping.`}
                            </li>
                            <li className="basket-suggestion-c__list-item">
                                {t`Virtually unlimited ergonomic positions.`}
                            </li>
                        </ul>
                    </div>
                    <div className="basket-suggestion-c__price-container">
                        <div className="basket-suggestion-c__price">
                            {format.money("$1,199.00")}
                        </div>
                        <div className="basket-suggestion-c__price-callout">
                            <span className="basket-suggestion-c__price-callout--underlined">
                                {t`$300 INSTANT CREDIT APPLIED IN CART`}
                            </span>
                        </div>
                    </div>
                    <div className="basket-suggestion-c__ctas">
                        {buildAddToBasketButton(props.product, addToBasket)}
                    </div>
                </div>
            </div>
        </div>
    );
};
